// BarcodeManager.js
import React, { useRef, useState, useEffect } from "react";
import { Modal, Button, Flex, Text } from "@mantine/core";
import Barcode from "react-barcode";
import { products_api } from "../pages/master/products/products.service";



export default function BarcodeManager({ barcodeData, productList = [], batchList = [], applicableDate = null, show, onClose, stockId }) {
  const [selectedBarcodes, setSelectedBarcodes] = useState(barcodeData || []);
  const [showReportModal, setShowReportModal] = useState(false);
  const [emptyOffset, setEmptyOffset] = useState(0);

  useEffect(() => {
    setSelectedBarcodes(barcodeData || []);
  }, [barcodeData]);

  const removeBarcode = (idx) => {
    setSelectedBarcodes((prev) => prev.filter((_, i) => i !== idx));
  };

  // === PRINT BARCODE ===
  const handleBarcodePrint = async () => {
    const printContent = document.getElementById("barcodePrintArea").innerHTML;
    const win = window.open("", "", "height=900,width=1200");
    win.document.write("<html><head><title>Barcode Print</title>");
    win.document.write(`
<style>
  @page {
    size: A4;
    margin: 0;
  }
  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
  }

  /* === Printable Page Layout === */
  .barcode-page {
    width: 210mm;
    height: 297mm;
    padding: 7mm 11mm; /* top/bottom 7mm, left/right 11mm */
    display: grid;
    grid-template-columns: repeat(5, 35mm);
    grid-template-rows: repeat(22, 10mm);
    gap: 3mm 3mm; /* vertical and horizontal gap */
    box-sizing: border-box;
    page-break-after: always;
  }

  /* === Each Sticker === */
  .barcode-item {
    width: 35mm;
    height: 10mm;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  /* === Barcode inside sticker === */
  .barcode-item svg {
    width: 33mm !important;
    height: 6mm !important; /* barcode area */
    display: block;
  }

  /* === Text below barcode === */
  .barcode-text {
    width: 33mm;
    font-size: 7px;
    text-align: center;
    line-height: 1;
    margin-top: 1mm;
    font-weight: 600;
  }
</style>
`);

    win.document.write("</head><body>");
    win.document.write(printContent);
    win.document.write("</body></html>");
    win.document.close();
    win.print();

    
  // ✅ Save barcode reference
  try {
 const payload = {
applicable_date: applicableDate || new Date().toISOString().split("T")[0], 
items: buildReportData().map((r) => {
   const matchedBatch = batchList.find(
  (b) =>
    String(b.batch_no).trim().replace(/\s+/g, "").toLowerCase() ===
      String(r.batch_no).trim().replace(/\s+/g, "").toLowerCase() &&
    String(b.product_code).trim() === String(r.product_code).trim()
);


    return {
      batch_id: matchedBatch?.id || null,
      qty: r.count,
    };
  }),
};


    await products_api.saveBarcodeReferences(payload);
  } catch (err) {
    console.error("Failed to save barcode references:", err);
  }
  // after printing → show report

  setTimeout(() => setShowReportModal(true), 600);
};

  // === PRINT REPORT ===
  const handleReportPrint = () => {
    const printContent = document.getElementById("reportPrintArea").innerHTML;
    const win = window.open("", "", "height=900,width=1200");
    win.document.write("<html><head><title>Report Print</title>");
    win.document.write(`
      <style>
        @page { size: A4; margin: 10mm; }
        body { font-family: Arial, sans-serif; }
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
        }
        th, td {
          border: 1px solid #000;
          padding: 6px;
        }
        tr {
          page-break-inside: avoid;
        }
      </style>
    `);
    win.document.write("</head><body>");
    win.document.write(printContent);
    win.document.write("</body></html>");
    win.document.close();
    win.print();
  };

  // === Build Report Data ===
 // === Build Report Data ===
const buildReportData = () => {
  const reportData = {};

  selectedBarcodes.forEach((code) => {
    const [productCode, batchNo] = code.split("-");
    const matchedProduct = productList.find(
      (p) => String(p.product_code) === String(productCode)
    );

    const matchedBatch = batchList.find(
      (b) =>
        String(b.product_code).trim() === String(productCode).trim() &&
        String(b.batch_no).trim().toLowerCase() ===
          String(batchNo).trim().toLowerCase()
    );

    const productName = matchedProduct ? matchedProduct.title : "-";
    const mrp = matchedBatch ? matchedBatch.mrp : "-";

    const key = `${productCode}-${batchNo}`;

    if (!reportData[key]) {
      reportData[key] = {
        product_code: productCode,
        product_name: productName,
        batch_no: batchNo || "-",
        mrp: mrp,
        count: 0,
      };
    }

    reportData[key].count += 1;
  });

const finalData = Object.values(reportData);

  // 🧾 Log everything clearly
  console.log("🧱 buildReportData() output:",finalData);

  // (optional) If you want even more detail:
  // console.log(JSON.stringify(finalData, null, 2));

  return finalData;};

  // === Split barcodes into pages of 64 ===
  const chunkBarcodes = (arr, size) =>
    arr.reduce((acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]), []);

  return (
    <>
      {/* ===== PREVIEW MODAL ===== */}
      <Modal
        opened={show && !showReportModal}
        onClose={onClose}

        title={
  <Flex justify="space-between" align="flex-start" w="100%" direction="column">
   


    <Text fw={600} style={{ margin: 20, marginBottom: 0 }}>
      Batch Barcodes (Preview)
    </Text>

    

    <Flex align="center" gap="md" style={{ marginLeft: 20, marginTop: 10 }}>


    {/* Start Offset Input */}
    <Flex align="center" gap="xs">
      <Text size="sm" fw={500}>Start Offset:</Text>
      <input
        type="number"
        min="0"
        placeholder="0"
        value={emptyOffset === 0 ? "" : emptyOffset}
        onChange={(e) => {
          const val = e.target.value;
          setEmptyOffset(val === "" ? 0 : Number(val));
        }}
        style={{
          width: "60px",
          height: "30px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          padding: "4px 6px",
          fontSize: "14px",
          textAlign: "center",
        }}
      />
    </Flex>

    {/* Counts Display */}
    <Flex align="center" gap="lg">
      <Text size="sm">
        <b>Total Items:</b> {buildReportData().length}
      </Text>
      <Text size="sm">
        <b>Total Count:</b> {buildReportData().reduce((sum, item) => sum + item.count, 0)}
      </Text>
    </Flex>

    {/* Print Button */}
    <Button color="green" onClick={handleBarcodePrint}>
      Print
    </Button>
  </Flex>
</Flex>

        }
        size="xl"
        fullScreen
          styles={{
    close: {
      backgroundColor: '#fac1c1ff',
      borderRadius: '50%',
      width: '32px',
      height: '32px',
      fontSize: '20px',
      color: '#ff0000ff',
      border: '1px solid #fdb3b3ff',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: '#e9ecef',
        transform: 'scale(1.1)',
      },
    },
  }}
      >
        <div style={{ maxWidth: "100%", margin: "0 auto", padding: 20 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 20,
            }}
          >
            {selectedBarcodes.map((code, idx) => (
              <div
                key={idx}
                style={{
                  border: "1px solid #ddd",
                  padding: 12,
                  borderRadius: 8,
                  background: "#fff",
                  position: "relative",
                }}
              >
                <Barcode value={code} height={60} width={1.8} displayValue={false} />
                <div style={{ marginTop: 6, fontWeight: 600, fontSize: 12 }}>{code}</div>
                <button
                  onClick={() => removeBarcode(idx)}
                  style={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>
      </Modal>

      {/* ===== REPORT MODAL ===== */}
      <Modal
        opened={showReportModal}
        onClose={() => setShowReportModal(false)}
        title={
          <Flex justify="space-between" align="center" w="100%">
            <Text fw={600} style={{ margin: 20 }}>Barcode Generation Report</Text>
            <Button color="green" onClick={handleReportPrint}>
              Print Report
            </Button>
          </Flex>
        }
        size="lg"
        styles={{
    close: {
      backgroundColor: '#fac1c1ff',
      borderRadius: '50%',
      width: '32px',
      height: '32px',
      fontSize: '20px',
      color: '#ff0000ff',
      border: '1px solid #fdb3b3ff',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: '#e9ecef',
        transform: 'scale(1.1)',
      },
    },
  }}
      >
        {/* ✅ NEW — DISPLAY STOCK ID */}
   {stockId && (
  <Text fw={500} style={{ marginLeft: 20, marginTop: 10, color: "#444" }}>
    Stock Transfer ID: {stockId}
  </Text>
)}

        <div style={{ padding: 20 }}>
  <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <thead>
      <tr>
        <th style={{ border: "1px solid #000", padding: 8 }}>Product Code</th>
        <th style={{ border: "1px solid #000", padding: 8 }}>Product Name</th>
        <th style={{ border: "1px solid #000", padding: 8 }}>Batch No</th>
        <th style={{ border: "1px solid #000", padding: 8 }}>MRP</th>
        <th style={{ border: "1px solid #000", padding: 8 }}>Barcodes Generated</th>
      </tr>
    </thead>
    <tbody>
      {buildReportData().map((item, idx) => (
        <tr key={idx}>
          <td style={{ border: "1px solid #000", padding: 8 }}>{item.product_code}</td>
          <td style={{ border: "1px solid #000", padding: 8 }}>{item.product_name}</td>
          <td style={{ border: "1px solid #000", padding: 8 }}>{item.batch_no}</td>
          <td style={{ border: "1px solid #000", padding: 8 }}>{item.mrp}</td>
          <td style={{ border: "1px solid #000", padding: 8, textAlign: "center" }}>
            {item.count}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

      </Modal>

      {/* ===== HIDDEN PRINT AREAS ===== */}
         <div id="barcodePrintArea" style={{ display: "none" }}>
         {(() => {
  // ✅ Step 1: Apply offset BEFORE chunking
  const offsetApplied = Array(emptyOffset)
    .fill("__EMPTY__")
    .concat(selectedBarcodes);

  // ✅ Step 2: Now chunk properly
  const pages = chunkBarcodes(offsetApplied, 110);

  // ✅ Step 3: Render
  return pages.map((page, pageIndex) => (
    <div key={pageIndex} className="barcode-page">
      {page.map((code, i) => (
        <div key={i} className="barcode-item">
          {code !== "__EMPTY__" ? (
            <>
              <Barcode value={code} height={25} width={1.2} displayValue={false} />
              <div className="barcode-text">{code} Quzone</div>
            </>
          ) : (
            <></> // Empty slot for offset spacing
          )}
        </div>
      ))}
    </div>
  ));
})()}


        </div>


      <div id="reportPrintArea" style={{ display: "none" }}>
        {stockId && (
  <Text fw={500} style={{ marginLeft: 5, marginTop: 10, color: "#000000ff" }}>
    Stock Transfer ID: {stockId}
  </Text>
)}

  <table style={{marginTop:10}}>
    <thead>
      <tr>
        <th>Product Code</th>
        <th>Product Name</th>
        <th>Batch No</th>
        <th>MRP</th>
        <th>Barcodes Generated</th>
      </tr>
    </thead>
    <tbody>
      {buildReportData().map((item, idx) => (
        <tr key={idx}>
          <td>{item.product_code}</td>
          <td>{item.product_name}</td>
          <td>{item.batch_no}</td>
          <td>{item.mrp}</td>
          <td style={{ textAlign: "center" }}>{item.count}</td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

    </>
  );
}
